import React, { Component } from "react";
import { Modal, Row, Col } from "antd";
import "./Modal.css";
import Compras1 from '../imagens/LancCompras/Compras1.png';
import Compras2 from '../imagens/LancCompras/Compras2.png';
import Compras3 from '../imagens/LancCompras/Compras3.png';
import Compras4 from '../imagens/LancCompras/Compras4.png';
import Compras5 from '../imagens/LancCompras/Compras5.png';
import Compras6 from '../imagens/LancCompras/Compras6.png';
import Compras7 from '../imagens/LancCompras/Compras7.png';
import Compras8 from '../imagens/LancCompras/Compras8.png';
import Compras9 from '../imagens/LancCompras/Compras9.png';
import Compras10 from '../imagens/LancCompras/Compras10.png';

export default class Compras extends Component {

    render() {

        const { isOpen, onClose } = this.props;

        return (
            <Modal
                title="Como criar Compras"
                className="modal"
                visible={isOpen}
                destroyOnClose
                onCancel={onClose}
                footer={null}
                width="50%"
                style={{ top: 10 }}
            >
                <Row>
                    <Col xs={24}>
                        <p>Para acessar o gerenciamento de Compras siga o seguinte atalho:  </p>

                        <div className="image-wrapper">
                            <img className="img_smaller" src={Compras1} alt="Compras 1" />
                        </div>

                        <div className="gray_bar"></div>

                        <div className="image-wrapper">
                            <img src={Compras2} alt="Compras 2" />
                        </div>

                        <h3>Na tela de Compras nós temos:</h3>
                        <ol>
                            <li>Botão para cadastrar uma nova compra.</li>
                            <li>Filtros para buscar as Compras.</li>
                            <li>Tabela mostrando todas as compras feitas.</li>
                            <li>Paginação da tabela de Compras.</li>
                        </ol>

                        <div className="gray_bar"></div>

                        <h3>Como cadastrar uma nova Compra</h3>
                        <p>
                            Para cadastrar uma nova Compra basta clicar no botão "Adicionar" no canto superior esquerdo da tela e inserir os dados
                            necessários da página de cadastro que é aberta.
                        </p>
                        <div className="image-wrapper">
                            <img src={Compras3} alt="Compras 3" />
                        </div>

                        <p>
                            O cadastro de compras possui três abas: Dados Principais serve para preencher as informações principais da Compra, a segunda de Lista dos Produtos
                            que serve para cadastrar os itens que foram comprados, e a terceira aba de Forma de Pagamento serve para informar as informações de Pagamento
                            e calcular parcelas e valores de parcelas dependendo da forma de pagamento selecionada.
                        </p>

                        <div className="image-wrapper">
                            <img src={Compras4} alt="Compras 4" />
                        </div>

                        <p>
                            Na primeira aba basta incluir as informações de data, observação e fornecedor de forma correta, na segunda aba o gestor irá adicionar os itens
                            que foram comprados. Para adicionar um novo item na lista basta clicar no botão "+ Novo produto" e preencher as informações na nova janela que for
                            aberta.
                        </p>

                        <div className="image-wrapper">
                            <img src={Compras5} alt="Compras 5" />
                        </div>

                        <div className="image-wrapper">
                            <img src={Compras6} alt="Compras 6" />
                        </div>
                        <p>
                            Caso o gestor quiser alterar/remover um iten da lista de itens, o gestor pode utilizar as opções auxiliares igual a imagem abaixo.
                        </p>
                        <div className="image-wrapper">
                            <img src={Compras7} alt="Compras 7" />
                        </div>
                        <p>
                            Depois de adicionar os itens a Compra o gestor deve acessar a terceira aba de Forma de Pagamento e calcular o valor e quantidade de parcelas
                            baseado na forma e condição de pagamento. Para calcular/altera as parcelas/excluir as parcelas o gestor pode utilizar os botões auxiliares marcados
                            na imagem abaixo.
                        </p>
                        <div className="image-wrapper">
                            <img src={Compras8} alt="Compras 8" />
                        </div>

                        <h3>Como excluir/alterar uma compra</h3>
                        <p>Para excluir/Alterar uma compra basta usar as opções auxiliares dentro da tabela de registros.</p>
                        <div className="image-wrapper">
                            <img src={Compras9} alt="Compras 9" />
                        </div>

                        <h3>Como filtrar as Compras</h3>
                        <p>Para facilitar a busca de Compras você pode utilizar os filtros avançados clicando no botão "Filtrar."</p>
                        <div className="image-wrapper">
                            <img src={Compras10} alt="Compras 10" />
                        </div>
                    </Col>
                </Row>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/tutoriais/LancCompras.js